export default __webpack_public_path__ + "static/media/tactSwitch.74e45931.png";